/**
 * Tries to parse a redirect string as a URL. Accepts both plain and URL-encoded strings.
 * @param {string} redirect - URL string (possibly encoded)
 * @param {string} [base] - Optional base URL for relative redirects
 * @returns {URL|null} Parsed URL or null if all attempts fail
 */
export function parseRedirectUrl(redirect, base) {
  const attempts = [
    () => new URL(redirect),
    () => new URL(decodeURIComponent(redirect)),
    ...(base ? [() => new URL(redirect, base), () => new URL(decodeURIComponent(redirect), base)] : []),
  ];
  for (const attempt of attempts) {
    try {
      return attempt();
    } catch {
      // continue to next attempt
    }
  }
  return null;
}
